import { render, staticRenderFns } from "./VFiltersWrapper.vue?vue&type=template&id=74bbac2f&"
import script from "./VFiltersWrapper.vue?vue&type=script&lang=js&"
export * from "./VFiltersWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports